import React, {useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ReactPlayer from "react-player";
import styles from './videoDialog.module.css';
import {Box, CircularProgress, useMediaQuery, useTheme} from "@mui/material";
import DialogHeader from "../dialogHeader";
import Vimeo, { EndEvent, PauseEvent, PlayEvent } from "@u-wave/react-vimeo";


const VideoDialog = ({show, setShow, video, title, videoID}: {
    show: boolean,
    setShow: (value: boolean) => void,
    video: string,
    title: string,
    videoID:number | string
}) => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const handleClose = () => {
        setShow(false)
        setVideoLoaded(false)
    }

    return (
        <Dialog
            fullWidth
            maxWidth={"md"}
            fullScreen={isMobile}
            open={show}
            onClose={handleClose}
        >

            <DialogHeader title={isMobile ? <Box component="img" margin="auto" display="flex"
                                                 src="https://www.performancegolf.com/wp-content/uploads/2023/11/Vector-1.png"
                                                 alt="logo"/> : title}
                          closeAction={handleClose}></DialogHeader>

            <DialogContent className={styles.videoModalContainer}>
                {/* <ReactPlayer
                    url={video}
                    style={{display: videoLoaded ? "block" : "none"}}
                    height={"100%"}
                    width={"100%"}
                    controls={true}
                    onReady={(event) => {
                        setVideoLoaded(true)
                    }}
                /> */}
                <Vimeo
                        showTitle={false}
                        video={videoID}
                        responsive={true}
                        playsInline={true}
                        autoplay={false}
                        color="FD3300"
                        onLoaded={(event) => {
                           // setTimeout(() => setVideoLoaded(true), 100);
                           setVideoLoaded(true);
                        }}
                />        
                {!videoLoaded && <Box sx={{
                    display: "flex",
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    top: 0,
                    left: 0
                }}>
                    <CircularProgress sx={{margin: "auto"}}/>
                </Box>
                }
            </DialogContent>
        </Dialog>
    );
};


export default VideoDialog;

